import { gql } from '@apollo/client'

export default gql(`
    mutation deleteBucketGroupType($id: ID! $project: String) {
        deleteBucketGroupType(
            input: {
                id: $id
            }
            project: $project
        ) {
            id
        }
    }`
)
